import { createContext, Dispatch, MutableRefObject, SetStateAction } from 'react';

export type ContextType = {
  isDialogOpen: boolean;
  setIsDialogOpen: Dispatch<SetStateAction<boolean>>;
  resultResolverRef: MutableRefObject<((result: boolean) => void) | undefined>;
  isEnabled: boolean;
  setIsEnabled: Dispatch<SetStateAction<boolean>>;
};

export const Context = createContext<ContextType | null>(null);
